var React = require('react');

function ScrollDownInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 1L12 51","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.75 44.5L12 51.25L5.25 44.5","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ScrollDownInline.defaultProps = {"width":"24","height":"55","viewBox":"0 0 24 55","fill":"none"};

module.exports = ScrollDownInline;

ScrollDownInline.default = ScrollDownInline;
